import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ReportWidgetDetailsFilterTableBaseDirective } from '../../../../../shared/report-widget-details-filter-table-base.directive';
import { isDefined } from '@fi-shared/utils';
import { IChecklistV2ReportParameterFilter } from '@fi-shared/checklist/fi-checklist2-report/shared/fi-checklist2-report';
import { WidgetTableFilterType } from '@fi-shared/checklist/fi-checklist2-report/enums/fi-checklist2-report-type';

@Component({
    selector: 'fi-recent-activity-details-filter-table',
    templateUrl: './fi-recent-activity-details-filter-table.component.html',
    styleUrls: ['./fi-recent-activity-details-filter-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-recent-activity-details-filter-table' },
    standalone: false,
})
export class FiRecentActivityDetailsFilterTableComponent
    extends ReportWidgetDetailsFilterTableBaseDirective
    implements OnInit
{
    @Output() onCloseDialog = new EventEmitter<void>();
    @Output() initialFilterUpdated = new EventEmitter<IChecklistV2ReportParameterFilter>();

    ngOnInit() {
        super.ngOnInit();
        setTimeout(() => {
            if (Object.keys(this.currentFilter)?.length > 1) {
                this.fiChecklist2ReportDataService.triggerFilterChanged(this.reportParam.Id);
            }
        });
        this.doPreventNewFilterInstanceAfterSave = true;
    }

    resetCurrentFilter() {
        this.currentFilter = this.getNewFilterInstance(undefined);
        this.currentFilterChange.emit(this.currentFilter);
    }

    setSelectedFilter(filterGuid: string) {
        super.setSelectedFilter(filterGuid);
        this.initialFilterUpdated.emit(this.initialFilter);
    }

    savedFilterChange() {
        this.saveReportParameter().then(() => {
            const currentSavedFilter: IChecklistV2ReportParameterFilter = this.reportParam.Settings.Filters.find(
                (filter: IChecklistV2ReportParameterFilter) => filter.Guid === this.currentFilter.Guid,
            );

            if (!this.currentFilter.Name?.length && !isDefined(currentSavedFilter)) return;

            if (this.isFilterRemoved(currentSavedFilter)) {
                this.setInitialFilterData();
                this.onCurrentFilterChanged();
                return;
            }

            if (this.isFilterRenamed(currentSavedFilter)) {
                this.setSelectedFilter(this.currentFilter.Guid);
                this.onCurrentFilterChanged();
                return;
            }
        });
    }

    private isFilterRemoved(currentSavedFilter: IChecklistV2ReportParameterFilter): boolean {
        return !!this.currentFilter.Name?.length && !isDefined(currentSavedFilter);
    }

    private isFilterRenamed(currentSavedFilter: IChecklistV2ReportParameterFilter): boolean {
        return (
            !!this.currentFilter.Name?.length &&
            isDefined(currentSavedFilter) &&
            currentSavedFilter.Name !== this.currentFilter.Name
        );
    }

    onCurrentFilterChanged() {
        super.onCurrentFilterChanged();
    }

    closeDialog() {
        this.onCloseDialog.emit();
    }

    protected readonly WidgetTableFilterType = WidgetTableFilterType;
}
